// This function calculates the users lvl, current lvl xp requirement and current xp in lvl, based on total xp score
// The funtion uses the fact that our lvl up system follows a geometric series.
// However there is a change in growth factor when the user reaches a certain lvl that needs to be accounted for.

export default function useCalculateLevel(xp: number): { lvl: number; xpToNextLvl: number; xpGainedThisLvl: number } {
  const startLvl = 1
  const startXP = 1000
  const startGrowth = 0.15
  const endGrowth = 0.01
  const growthChangeLvl = 20

  let lvl = startLvl
  let xpToNextLvl = startXP
  let growthFactor = 1 + startGrowth
  xp -= xpToNextLvl
  // eslint-disable-next-line
  while (xp >= 0) {
    if (lvl >= growthChangeLvl) {
      growthFactor = 1 + endGrowth
    }

    xpToNextLvl = Math.round(Math.round(xpToNextLvl * growthFactor) / 100) * 100 // Double rounding to avoid float point errors
    xp -= xpToNextLvl
    lvl++
  }

  const xpGainedThisLvl = xpToNextLvl + xp

  return { lvl, xpGainedThisLvl, xpToNextLvl }
}
